import { useState, useEffect } from 'react'
import { Dashboard } from './pages/Dashboard'
import { Login } from './pages/Login'
import { supabase } from './services/supabase'
import { AdminSession } from './types'

function App() {
  const [session, setSession] = useState<AdminSession | null>(null)
  const [loading, setLoading] = useState(true)

  // Check auth status on mount
  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session as AdminSession | null)
      setLoading(false)
    })

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session as AdminSession | null)
    })

    return () => subscription.unsubscribe()
  }, [])

  if (loading) {
    return (
      <div className="login">
        <div style={{ textAlign: 'center' }}>
          <div className="spinner"></div>
          <p style={{ marginTop: '1rem', color: '#6B7280' }}>Loading...</p>
        </div>
      </div>
    )
  }

  if (!session) {
    return <Login onLogin={(s) => setSession(s as AdminSession)} />
  }

  return <Dashboard session={session} onLogout={() => setSession(null)} />
}

export default App
